import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
//import { SlimLoadingBarService } from '../slim-loading-bar/slim-loading-bar.service';
import showdown from 'showdown';

import { Page } from '../page';
import { PageService } from '../page.service';
import { jQuery, $ } from 'jquery/dist/jquery';
import { Title } from '@angular/platform-browser';

//var showdown  = require('showdown');


@Component({
  selector: 'app-page-view',
  templateUrl: './page-view.component.html',
  styleUrls: ['./page-view.component.css'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class PageViewComponent implements OnInit {
  @Input() page: Page; 
  uid: string; 
  title: string;
  public loading: boolean = true;
  nextpage_uid: string;
  prevpage_uid: string;

  constructor(
    private route: ActivatedRoute,
    private pageService: PageService,
    private location: Location,
    private http: HttpClient,
	private titleService: Title,
	//private slimLoadingBarService: SlimLoadingBarService
  ) { }

  ngOnInit() {
	const uid = this.route.snapshot.paramMap.get('uid');
	this.uid = uid;
	
	this.title = this.pageService.getTitleForUid(this.uid);

	this.titleService.setTitle('천지성공 가이드북: ' + this.title);

	this.nextpage_uid = this.pageService.getNextPageUid(this.uid);
	this.prevpage_uid = this.pageService.getPrevPageUid(this.uid);
	
	this.getPage();

	//console.log("this.nextpage_uid" + this.nextpage_uid);
	//console.log("this.prevpage_uid" + this.prevpage_uid);
  }


    startLoading() {
        //this.slimLoadingBarService.start(() => {
            //console.log('Loading complete');
        //});
    }

    stopLoading() {
        //this.slimLoadingBarService.stop();
    }

    completeLoading() {
        //this.slimLoadingBarService.complete();
    }
	
  getPage(): void {
	var page_json = null;
	this.startLoading();
    this.pageService.getPageData(this.uid)
      .subscribe(data => page_json = data, 
        error => { console.log("Error: ", error); this.stopLoading(); },
		//() => this._router.navigate(['HeroDetail', { id: this.hero.id }])
		() => { this._parsePageJson(page_json); this.loading = false; });
  }
  
  _parsePageJson(page_json): void {
	  //console.log(page_json);
	  //var article = JSON.parse(page_json);
	  if(page_json == null) {
		  this.page = new Page();
		  this.page.uid = this.uid; 
		  this.page.subject = "no title";
		  this.page.content = "no content";		  

	  } else {
		  var p = page_json['article'];
		  //console.log(p);
		  this.page = new Page(); 
		  this.page.uid = this.uid; 
		  this.page.subject = this.title; //p.title;
		  
		  var converter = new showdown.Converter();
		  
		  this.page.content = converter.makeHtml(p.content);
	  }

	  //this.slimLoadingBarService.complete();

	  //console.log(this.page);
  }
  
  goBack(): void {
    this.location.back();
  }
  
  onResize(event) {
	  //console.log(event.target.innerWidth);
	 if(event.target.innerWidth <= 900) {
		 //window.$ = jQuery;
		$(".content img").each(function() {
			$(this).attr('width', '')
				.css('width', '100%');
		});
	 
	 }
  }
  
}
